import React from 'react';
import './Cta-Button-1-Preview.scss';

const CtaButton1Preview = (props) => {
  const { config } = props;

  return (
    <div className={config?.cta?.title ? 'cta-button-title-value' : 'cta-button-empty'}>
      {config?.cta?.title || 'CTA TITLE'}
    </div>
  );
};

export default CtaButton1Preview;
